(function() {
    'use strict';

        angular
            .module('iMatApp')
            .controller('promoMessageController', promoMessageController);

        promoMessageController.$inject = ['$uibModalInstance','promoMessage'];
        function promoMessageController($uibModalInstance, promoMessage) {
            var vm = this;

            vm.dontShowAgain = false;
            vm.promoMessage = null;
            vm.close = close;

            activate();

            //------------------------------------------------------------

            function activate() {
                vm.promoMessage = promoMessage;
            }

            function close() {
                $uibModalInstance.close({ promoMessageId: vm.promoMessage.id, dontShowAgain: vm.dontShowAgain });
            }
        }
})();